import getPublicEnv from '@utils/getPublicEnv';

const IsCustomerMiddleware = ({ children }) => {
  const isServerSide = typeof window === 'undefined';
  const isCustomer = isServerSide ? process.env.IS_CUSTOMER : getPublicEnv('NEXT_PUBLIC_IS_CUSTOMER');
  return isCustomer === 'true' ? <>{children}</> : <></>;
};

export default IsCustomerMiddleware;
